<template>
<div>
    <b-container>
        <b-row class="headerpic" align-v="center">
            <b-col>
                <span class="txtabout"><b><span class="txtbolder">graphic</span></b> design & advertising agency</span>
            </b-col>
            <b-col class="col-6">
                <b-img class="gdgrid" :src="wurl+'/imgsrv/gdgrid.png'" fluid alt="Responsive image"></b-img>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <br>
                <b-breadcrumb :items="items"></b-breadcrumb>
            </b-col>
        </b-row>

        <b-row class="content">
            <b-col>
                <b-card v-if="langfrench" class="shadow">
                    <div v-html="content_fr"></div>
                </b-card>
                <b-card v-else class="shadow">
                    <div v-html="content_en"></div>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import axios from 'axios'
import {
    globalSiteSetting
} from "../main.ts";
export default {
    data() {
        return {
            wurl: globalSiteSetting.siteurl,
            items: [],
            items_fr: [{
                    text: 'Accueil',
                    to: '/'
                },
                {
                    text: 'L\'Agence',
                    active: true
                }
            ],
            items_en: [{
                    text: 'Home',
                    to: '/'
                },
                {
                    text: 'About',
                    active: true
                }
            ],
            langfrench: Boolean,
            content: '',
            content_fr: '',
            content_en: '',
            title_fr: '',
            title_en: '',

            headerpic: 'banner_gd.gif'
        }
    },
    methods: {
        retrievedata() {
            var app = this
            var weburl = this.wurl
            axios.get(weburl + '/api.data.php?req=content&p=aboutus&auth=razafy', {
                    crossDomain: true
                })
                .then(response => {
                    //console.log('title is:'+ response.data.title)
                    // console.log('content is:'+ response.data.content)
                    //console.log('headerpic is:' + response.data.headerpic)

                    this.title_fr = response.data.title_fr
                    this.content_fr = response.data.content_fr

                    this.title_en = response.data.title_en
                    this.content_en = response.data.content_en

                    this.headerpic = response.data.headerpic

                    //console.log('ato ary o content_en:'+this.content_en)

                    //attribute default value for french
                    if (this.langfrench == true) {
                        this.content = this.content_fr
                    }
                })
        },
        scrollToTop() {
            // scroll on top every load page        
            window.scrollTo(0, 0);
        },

        togglefrenchlangage() {
            this.langfrench = true
            this.items = this.items_fr
            this.content = this.content_fr
            // console.log('lang is now french in about')
            //change page title
            window.document.title = 'Graphikodesign | L\'Agence'
        },
        toggleenglishlangage() {
            this.langfrench = false
            this.items = this.items_en
            this.content = this.content_en
            // console.log('lang is now english in about')
            //change page title
            window.document.title = 'Graphikodesign | About'
        },
        checkifcookieexistornot() {

            if (this.$cookie.get('gd_langinfrench') === 'true') {
                this.langfrench = true
                this.content = this.content_fr
                EventBus.$emit('togglelangtofrench')
            } else {
                this.langfrench = false
                this.content = this.content_en
                //console.log('ato o....and content is:'+this.content_en)
                EventBus.$emit('togglelangtoenglish')
            }
        }

    },

    mounted() {
        this.retrievedata()
        this.scrollToTop()
        this.checkifcookieexistornot()

        if (this.langfrench == true) {
            this.items = this.items_fr
            //change page title
            window.document.title = 'Graphikodesign | L\'Agence'
        } else {
            this.items = this.items_en
            //change page title
            window.document.title = 'Graphikodesign | About'
        }

        //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }

}
</script>
